import { __assign, __rest } from "tslib";
import React from 'react';
import { Launch20 } from '@carbon/icons-react';
import cx from 'classnames';
export var Link = function (_a) {
    var children = _a.children, href = _a.href, className = _a.className, _b = _a.externalLink, externalLink = _b === void 0 ? false : _b, _c = _a.inlineLink, inlineLink = _c === void 0 ? false : _c, rest = __rest(_a, ["children", "href", "className", "externalLink", "inlineLink"]);
    return (React.createElement("a", __assign({}, rest, { href: href, className: cx('flex items-center  text-matisse hover:underline', {
            'no-underline': !externalLink && !inlineLink,
            underline: inlineLink,
            'visited:text-minsk visited:hover:text-valhalla underline': inlineLink || externalLink,
        }, className) }),
        children,
        externalLink && React.createElement(Launch20, { className: "ml-1" })));
};
export default Link;
